import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import toast from 'react-hot-toast';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const rawApiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").trim();
const normalizedApiBaseUrl = rawApiBaseUrl.replace(/\/+$/, "");
const isLocalApiHost = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(normalizedApiBaseUrl);
const isBrowser = typeof window !== "undefined";
const isDeployedFrontend =
  isBrowser && !/^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

// In deployment, if env is not set correctly (or still localhost), call same host.
const API_BASE_URL =
  isDeployedFrontend && (!normalizedApiBaseUrl || isLocalApiHost)
    ? window.location.origin
    : normalizedApiBaseUrl;

axios.defaults.baseURL = API_BASE_URL;

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || localStorage.getItem("employeeToken");
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Prevent accidental /api/api duplication when env base URL ends with /api
  // and requests are written as /api/...
  if (typeof config.baseURL === "string" && typeof config.url === "string") {
    const normalizedBase = config.baseURL.replace(/\/+$/, "");
    if (normalizedBase.endsWith("/api") && config.url.startsWith("/api/")) {
      config.url = config.url.replace(/^\/api/, "");
    }
  }

  return config;
});

const patchToastType = (type) => {
  const original = toast[type];
  toast[type] = (message, options = {}) => {
    const toastId = options.id || `${type}:${String(message)}`;
    return original(message, { ...options, id: toastId });
  };
};

patchToastType("error");
patchToastType("success");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
